export default "__VITE_ASSET__CDQfcYGC__"